const UPLUS_TRADE_HOME = 'https://www.uplustrade.com'
const SOURCE_KEY = 'uplusTradeLogoSource'
const SOURCE_HISTORY_LENGTH_KEY = 'uplusTradeLogoSourceHistoryLength'

function isUPlusTradeHost(hostname) {
  const host = String(hostname || '').toLowerCase()
  return host === 'uplustrade.com' || host === 'www.uplustrade.com'
}

function isUPlusTradeEntry() {
  if (typeof window === 'undefined') return false
  const hashPath = String(window.location.hash || '').split('?')[0]
  const source = new URLSearchParams(window.location.search).get('from')
  return window.location.pathname === '/robot' || hashPath === '#/robot' || isUPlusTradeHost(source)
}

function rememberUPlusTradeSource() {
  if (window.sessionStorage.getItem(SOURCE_KEY)) return
  window.sessionStorage.setItem(SOURCE_KEY, UPLUS_TRADE_HOME)
  window.sessionStorage.setItem(SOURCE_HISTORY_LENGTH_KEY, String(window.history.length))
}

function clearUPlusTradeSource() {
  window.sessionStorage.removeItem(SOURCE_KEY)
  window.sessionStorage.removeItem(SOURCE_HISTORY_LENGTH_KEY)
}

function captureUPlusTradeSource() {
  if (typeof window === 'undefined' || typeof document === 'undefined') return

  try {
    if (isUPlusTradeEntry()) {
      rememberUPlusTradeSource()
      return
    }
    if (!document.referrer) return
    const referrer = new URL(document.referrer)
    if (isUPlusTradeHost(referrer.hostname)) {
      rememberUPlusTradeSource()
      return
    }
    if (referrer.hostname !== window.location.hostname) clearUPlusTradeSource()
  } catch (error) {
    clearUPlusTradeSource()
  }
}

function externalLogoTarget() {
  if (typeof window === 'undefined') return ''
  captureUPlusTradeSource()
  try {
    return window.sessionStorage.getItem(SOURCE_KEY) || ''
  } catch (error) {
    return ''
  }
}

export function navigateFromLogo(router, fallbackPath) {
  const externalTarget = externalLogoTarget()
  const currentPath = router && router.currentRoute ? router.currentRoute.path : ''
  const isOverviewHome = fallbackPath === '/app/overview' && currentPath === '/app/overview'
  const isPublicHome = fallbackPath === '/' && ['/', '/login', '/register'].includes(currentPath)

  if (externalTarget) {
    const entryHistoryLength = Number(window.sessionStorage.getItem(SOURCE_HISTORY_LENGTH_KEY))
    clearUPlusTradeSource()

    if (Number.isFinite(entryHistoryLength) && entryHistoryLength > 1 && window.history.length > 1) {
      const returnSteps = Math.max(1, window.history.length - entryHistoryLength + 1)
      window.history.go(-returnSteps)
      window.setTimeout(() => window.location.replace(externalTarget), 500)
      return
    }

    window.location.replace(externalTarget)
    return
  }

  if (isOverviewHome || isPublicHome) {
    window.location.replace(UPLUS_TRADE_HOME)
    return
  }

  if (currentPath !== fallbackPath) router.push(fallbackPath)
}

captureUPlusTradeSource()